import angular from 'angular';
import gettext from 'angular-gettext';
/**
 * contentTopDecorator decorates content-top directive from BlurAdmin.
 * The reason behind the change is to provide template with translations to the state titles.
 *
 * @memberof BlurAdmin
 * @param {Array} $delegate all definitions matching "contentTopDirective"
 * @returns {*} Overrided directive definitions
 */
/** @ngInject */
let contentTopDecorator = function backTopDecorator($delegate) {
    $delegate.forEach(function(directiveDeffinition){
        directiveDeffinition.template = require('./content-top.html');

        /** @ngInject */
        directiveDeffinition.controller = function($scope, $state, $stateParams) {

            $scope.pageTitle = () => $stateParams.pageTitle;

            $scope.showTopBar = () => {
                let current = $state.current;
                if(current.breadcrumbsMeta && (typeof current.breadcrumbsMeta.topBar !== 'undefined')) {
                    return current.breadcrumbsMeta.topBar;
                }
                return true;
            }

            /**
             * Go to state - use returnState $stateParams to include eg. grid sorting
             * @param stateName
             */
            $scope.goToState = function(stateName) {

                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params)
                } else {
                    $state.go(stateName, {})
                }
            };

            $scope.$watch(function () {
                let current = $state.current;
                if(current.breadcrumbsMeta && current.breadcrumbsMeta.parentState) {
                    $scope.parentState = $state.get(current.breadcrumbsMeta.parentState);
                } else {
                    $scope.parentState = null;
                }
            });
        }
    });
    return $delegate;
};

let contentTopDecoratorConfig = function($provide) {
    /** @ngInject */

    $provide.decorator('contentTopDirective', contentTopDecorator);
};

export default angular.module('cms.blur-admin.content-top', ['BlurAdmin.theme.components', gettext])
    .config(contentTopDecoratorConfig).name;


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/contentTopDecorator/contentTopDecorator.js